module.exports = __webpack_public_path__ + "static/media/financial2.38070682.png";